import React, { useEffect, useState } from "react";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import Main from "../../components/layout/Main";
import { Button, Form, Input, Modal } from "antd";
import { Pencil, Trash2 } from "lucide-react";
import PhoneInput from "react-phone-input-2";
import ApartmentIcon from "../../assets/images/apartment-icon.svg";
import VillaIcon from "../../assets/images/house-villa-icon.svg";
import OfficeIcon from "../../assets/images/office-icon.svg";
import DeleteAddressModal from "./DeleteAddressModal";
import { getCoordinates } from "../../helper/functions";
import { Severty, ShowToast } from "../../helper/toast";
import { useStore } from "../../context/StoreContext";
import LocationPicker from "../../components/LocationPicker";
import { update } from "lodash";

const addressTypes = [
  { type: "Apartment", icon: ApartmentIcon },
  { type: "House/Villa", icon: VillaIcon },
  { type: "Office", icon: OfficeIcon },
];

const DeliveryAddresses = () => {
  const [addressType, setAddressType] = useState("Apartment");
  const [form] = Form.useForm();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selected, setSelected] = useState(0);
  const { addAddress, loadAddress, deleteAddress } = useStore();
  // const [open, setOpen] = useState(false);
  const [modalState, setModalState] = useState({
    open: false,
    isEditMode: false,
    data: null,
  });

  const [opendelete, setOpen01] = useState(false);
  const [addresses, setAddresses] = useState([]);

  // -------- handlers ---------
  const loadAddresses = async () => {
    const response = await loadAddress();
    if (response.status === 200) {
      setAddresses(response.data.addresses);
    }
  };

  const handleDeleteAddress = async (addressId) => {
    const response = await deleteAddress(addressId);
    if (response.status === 200) {
      ShowToast(response.message, Severty.SUCCESS);
      setOpen01(false);
      loadAddresses();
    }
  };

  const onFinish = async (values) => {
    try {
      const coordinates = await getCoordinates();

      // remove phone from values using destructuring
      const { phone, ...restValues } = values;

      let addressData = {
        ...restValues,
        type: addressType,
        latitude: String(coordinates.latitude),
        longitude: String(coordinates.longitude),
      };

      // If phone number is provided, format it properly
      if (phone) {
        let countryCode, number;

        if (phone.length === 12) {
          countryCode = phone.substring(0, 2);
          number = phone.substring(2);
        } else if (phone.length === 13) {
          countryCode = phone.substring(0, 3);
          number = phone.substring(3);
        } else if (phone.length === 11) {
          countryCode = phone.substring(0, 1);
          number = phone.substring(1);
        }

        addressData = {
          ...addressData,
          mobileNumber: number,
          countryCode: `+${countryCode}`,
        };
      }
      let response;
      if (modalState.isEditMode) {
        // response = await updateAddress(addressData);
      } else {
        response = await addAddress(addressData);
      }
      if (response.status === 200 || response.status === 201) {
        ShowToast(response.message, Severty.SUCCESS);
        form.resetFields();
        loadAddresses();
        setModalState({ open: false, isEditMode: false, data: null });
      }
    } catch (error) {}
  };

  // -------- use effects ---------
  useEffect(() => {
    loadAddresses();
    if (modalState.isEditMode) {
      const { data } = modalState;
      data.phone = `${data.countryCode} ${data.mobileNumber}`;
      form.setFieldsValue(modalState.data);
    }
    if (modalState.open === false) {
      form.resetFields();
    }
    // eslint-disable-next-line
  }, [modalState.isEditMode]);

  return (
    <Main>
      <div className="delivery-page">
        <div className="delivery-header">
          <h2>My Delivery Addresses</h2>
          <Button
            className="add-btn"
            onClick={() =>
              setModalState({ open: true, isEditMode: false, data: null })
            }
          >
            <PlusOutlined /> Add a new address
          </Button>
        </div>

        <div className="address-list">
          {addresses?.length > 0 ? (
            addresses?.map((addr, index) => (
              <div
                key={index}
                className={`address-card ${
                  selected === index ? "selected" : ""
                }`}
              >
                <div className="address-top">
                  <input
                    type="radio"
                    checked={selected === index}
                    onChange={() => setSelected(index)}
                  />
                  <div className="address-info">
                    <h3>{addr?.name}</h3>
                    <p>{`${addr?.type}, ${addr.countryCode} ${addr?.mobileNumber}`}</p>
                    <p>{addr?.fullAddress}</p>
                  </div>
                </div>
                <div className="address-actions">
                  <button
                    className="edit-btn"
                    onClick={() =>
                      setModalState({
                        open: true,
                        isEditMode: true,
                        data: addr,
                      })
                    }
                  >
                    <Pencil /> Edit
                  </button>
                  <button
                    className="delete-btn"
                    onClick={() => setOpen01(true)}
                  >
                    <Trash2 /> Delete
                  </button>
                  {/* Delete Address Modal */}
                  <DeleteAddressModal
                    open={opendelete}
                    onClose={() => setOpen01(false)}
                    address={
                      addr?.fullAddress ||
                      "Dubai - United Arab Emirates, Dubai, United Arab Emirates"
                    }
                    onDelete={() => handleDeleteAddress(addr?._id)}
                  />
                </div>
              </div>
            ))
          ) : (
            <h2 className="text-white text-center mt-5">No addresses found</h2>
          )}
        </div>
      </div>

      {/* Modal */}
      <Modal
        open={modalState.open}
        footer={null}
        closable={false}
        width={956}
        className="delivery-modal delivery-modal_for_map"
      >
        <div className="delivery-modal-container">
          {/* Left Side */}
          <div className="delivery-form">
            <div className="delivery-header">
              <h2>Delivery address</h2>
              <Button
                icon={<CloseOutlined />}
                onClick={() =>
                  setModalState({ open: false, isEditMode: false, data: null })
                }
                className="close-btn"
              />
            </div>

            <div className="address-type-selector">
              {addressTypes.map(({ type, icon }) => (
                <div
                  key={type}
                  className={`address-type ${
                    addressType === type ? "selected" : ""
                  }`}
                  onClick={() => setAddressType(type)}
                >
                  <img src={icon} alt={type} className="address-type-icon" />
                  <span className="address-type-label">{type}</span>
                </div>
              ))}
            </div>

            <Form form={form} name="address_details" layout="vertical">
              {/* Street Address */}
              <Form.Item
                name="streetAddress"
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value || value.trim() === "") {
                        if (!value) {
                          return Promise.reject(
                            new Error("Please enter your street address!")
                          );
                        } else {
                          return Promise.reject(
                            new Error(
                              "Street address cannot be empty or just spaces"
                            )
                          );
                        }
                      }
                    },
                  },
                ]}
              >
                <Input placeholder="Street Address*" className="input-full" />
              </Form.Item>

              {/* Apartment Number */}
              <Form.Item
                name="houseNumber"
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value || value.trim() === "") {
                        if (!value) {
                          return Promise.reject(
                            new Error(
                              "Please enter your apartment/office/villa number!"
                            )
                          );
                        } else {
                          return Promise.reject(
                            new Error(
                              "apartment/office/villa number cannot be empty or just spaces"
                            )
                          );
                        }
                      }
                    },
                  },
                ]}
              >
                <Input
                  placeholder="Enter your apartment/office/villa number*"
                  className="input-full"
                />
              </Form.Item>

              {/* Country */}
              <Form.Item
                name="country"
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value || value.trim() === "") {
                        if (!value) {
                          return Promise.reject(
                            new Error("Please enter your country!")
                          );
                        } else {
                          return Promise.reject(
                            new Error("Country cannot be empty or just spaces")
                          );
                        }
                      }
                    },
                  },
                ]}
              >
                <Input placeholder="Country*" className="input-full" />
              </Form.Item>
              {/* State */}
              <Form.Item
                name="state"
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value || value.trim() === "") {
                        if (!value) {
                          return Promise.reject(
                            new Error("Please enter your state!")
                          );
                        } else {
                          return Promise.reject(
                            new Error("State cannot be empty or just spaces")
                          );
                        }
                      }
                    },
                  },
                ]}
              >
                <Input placeholder="State*" className="input-full" />
              </Form.Item>

              {/* Avenue */}
              <Form.Item name="avenue">
                <Input placeholder="Avenue (Optional)" className="input-full" />
              </Form.Item>

              <div className="address-personal-information">
                Personal Information
              </div>
              {/* Phone Number Input */}
              <Form.Item
                name="phone"
                className="main-new-height-mobile-input"
                rules={[
                  {
                    required: true,
                    message: "Please enter your phone number!",
                  },
                  {
                    validator: (_, value) => {
                      if (
                        !value ||
                        value.trim() === "" ||
                        value === "undefined"
                      ) {
                        return Promise.reject(
                          new Error("Phone number is required")
                        );
                      }

                      // ✅ Remove spaces and '+' and check if it's digits
                      const digits = value.replace(/\D/g, "");
                      if (digits.length < 8) {
                        return Promise.reject(
                          new Error("Please enter a valid phone number")
                        );
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <PhoneInput
                  country="kw"
                  defaultCountry="kw"
                  value={phoneNumber}
                  onChange={setPhoneNumber}
                  inputStyle={{
                    width: "100%",
                    height: "57px",
                    borderRadius: "0px",
                    background: "transparent",
                    // color: "white",
                    border: "none",
                    fontSize: "16px",
                  }}
                  buttonStyle={{
                    background: "#54545469",
                    border: "none",
                    borderRadius: "8px 0 0 8px",
                    height: "57px",
                    color: "white",
                  }}
                  containerStyle={{
                    height: "57px",
                    borderRadius: "12px",
                    background: "#54545469",
                    border: "none",
                  }}
                  dropdownStyle={{
                    background: "#2a2a2a",
                    border: "1px solid #54545469",
                    borderRadius: "12px",
                    color: "white",
                  }}
                  placeholder="Phone Number"
                />
              </Form.Item>
              {/* Name */}
              <Form.Item
                name="name"
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value || value.trim() === "") {
                        if (!value) {
                          return Promise.reject(
                            new Error("Please enter your name!")
                          );
                        } else {
                          return Promise.reject(
                            new Error(
                              "Full name cannot be empty or just spaces"
                            )
                          );
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input placeholder="Enter your name*" className="input-full" />
              </Form.Item>
              <Button
                className="Fill-button"
                onClick={() => {
                  onFinish(form.getFieldsValue(true));
                }}
              >
                Add Address
              </Button>
            </Form>
          </div>

          {/* Right Side - Map */}
          <div className="map-area">
            <LocationPicker
              onLocationSelect={(location) => {
                form.setFieldsValue({
                  streetAddress: location.address,
                  state: location.state,
                  country: location.country,
                });
              }}
            />
          </div>
        </div>
      </Modal>
    </Main>
  );
};

export default DeliveryAddresses;
